import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useMemo, useState } from 'react';
import moment from 'moment';
import User from '_class/User';
import DateTime from '_class/DateTime';
import { useTranslate } from 'lib/translate';
import { Collapsible } from 'UI';
import { Button, ButtonGroup, Checkbox, Flex, Table } from '@haldor/ui';

var ReportHistory = function ReportHistory(_ref) {
  var attendance = _ref.attendance;

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      reportHistory = _useState2[0],
      setReportHistory = _useState2[1];

  var translate = useTranslate();

  var getReportedBy = function getReportedBy(item) {
    if (item.reportedBy != null && item.reportedBy.firstName != null) {
      var reportedBy = new User(item.reportedBy);
      return reportedBy.getName();
    }

    if (item.reportedBy != null) {
      if (item.reportedBy.userId == 'TrackAttendance') {
        return translate('system');
      }

      if (item.reportedBy != '') {
        return translate('Guardian');
      }
    }

    return null;
  };

  var getRemovedBy = function getRemovedBy(item) {
    if (item.editor != null && item.editor.firstName != null) {
      var editor = new User(item.editor);
      return editor.getName();
    }

    return null;
  };

  useMemo(function () {
    if (attendance == null) {
      return false;
    }

    var attendanceList = [];
    attendance.forEach(function (item) {
      var reducedItem = _objectSpread({}, item);

      if (reducedItem.history != null && reducedItem.history.length > 0) {
        item.history.forEach(function (historyItem) {
          attendanceList.push(historyItem);
        });
        delete reducedItem.history;
      }

      attendanceList.push(reducedItem);
    });
    var attendanceHistory = attendanceList.filter(function (attendance) {
      return attendance.status == 'Deleted';
    });
    var reportHistory = [];
    attendanceHistory.forEach(function (item) {
      var historyFound = reportHistory.findIndex(function (history) {
        return moment(history.edited).isSame(moment(item.edited), 'second');
      });

      if (historyFound > -1) {
        reportHistory[historyFound].items.push(item);
      } else {
        var reportHistoryItem = {
          reported: item.reported,
          reportedBy: item.reportedBy,
          edited: item.edited,
          editor: item.editor,
          items: [item]
        };
        reportHistory.push(reportHistoryItem);
      }
    });
    setReportHistory(reportHistory);
  }, [attendance]);

  if (reportHistory.length == 0) {
    return null;
  }

  return /*#__PURE__*/React.createElement("div", {
    style: {
      margin: '1.5rem 1.7rem',
      marginBottom: 0
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "title"
  }, translate('Removed reports')), reportHistory.map(function (history, index) {
    var trigger = /*#__PURE__*/React.createElement(Flex, {
      center: true,
      space: true
    }, /*#__PURE__*/React.createElement("div", {
      className: "size-16",
      style: {
        fontWeight: 400
      }
    }, new DateTime(history.edited).getLongDateWithTime()), /*#__PURE__*/React.createElement("div", {
      className: "size-16",
      style: {
        fontWeight: 400
      }
    }, translate('reported-by'), " ", getReportedBy(history)), /*#__PURE__*/React.createElement("div", {
      className: "size-16",
      style: {
        fontWeight: 400
      }
    }, getRemovedBy(history) != null ? translate('Removed by') + ' ' + getRemovedBy(history) : null));
    var style = {};

    if (index + 1 < reportHistory.length) {
      style = {
        marginBottom: '.75rem'
      };
    }

    return /*#__PURE__*/React.createElement("div", {
      key: history.reported,
      style: style
    }, /*#__PURE__*/React.createElement(Collapsible, {
      trigger: trigger
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        marginTop: '.55rem'
      }
    }), /*#__PURE__*/React.createElement(Table, null, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, translate('name')), /*#__PURE__*/React.createElement("th", null, translate('absent')), /*#__PURE__*/React.createElement("th", null, translate('minutes')), /*#__PURE__*/React.createElement("th", null, translate('mark-for-valid-absence')), /*#__PURE__*/React.createElement("th", null, translate('Absence length')), /*#__PURE__*/React.createElement("th", null, translate('reported-by')), /*#__PURE__*/React.createElement("th", null, translate('reported')))), /*#__PURE__*/React.createElement("tbody", null, history.items.map(function (item) {
      var user = new User(item.user);
      return /*#__PURE__*/React.createElement("tr", {
        key: item.id
      }, /*#__PURE__*/React.createElement("td", {
        title: item.user.email
      }, user.getName()), /*#__PURE__*/React.createElement("td", {
        style: {
          whiteSpace: 'nowrap',
          verticalAlign: 'top'
        }
      }, /*#__PURE__*/React.createElement(ButtonGroup, null, /*#__PURE__*/React.createElement(Button, {
        type: "secondary",
        style: item.type == 'PRESENT' || item.type == 'VALID_PRESENT' ? {
          backgroundColor: '#4baf4d',
          borderColor: '#4baf4d',
          color: 'white'
        } : {},
        disabled: true
      }, translate('present')), /*#__PURE__*/React.createElement(Button, {
        type: "secondary",
        style: item.type == 'INVALID_ABSENCE' || item.type == 'VALID_ABSENCE' ? {
          backgroundColor: '#df2d2e',
          borderColor: '#df2d2e',
          color: 'white'
        } : {},
        disabled: true
      }, translate('absent-whole')), /*#__PURE__*/React.createElement(Button, {
        type: "secondary",
        style: item.type == 'INVALID_LATE' || item.type == 'VALID_LATE' ? {
          backgroundColor: '#f38234',
          borderColor: '#f38234',
          color: 'white'
        } : {},
        disabled: true
      }, translate('late-partly')))), /*#__PURE__*/React.createElement("td", {
        style: {
          textAlign: 'left',
          width: 60,
          verticalAlign: 'top'
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-row"
      }, item.type.indexOf('LATE') > -1 ? /*#__PURE__*/React.createElement("input", {
        style: {
          width: 60
        },
        type: "number",
        min: "0",
        max: "500",
        value: item.lateDuration,
        disabled: true
      }) : /*#__PURE__*/React.createElement("div", {
        style: {
          width: 60,
          height: 23,
          marginBottom: 3
        }
      }))), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", null, item.type != 'PRESENT' && item.type != 'VALID_PRESENT' ? /*#__PURE__*/React.createElement(Checkbox, {
        value: item.type.indexOf('VALID') == 0,
        style: {
          "float": 'right'
        },
        disabled: true
      }) : null)), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", null, translate('From'), ": ", new DateTime(item.startTime).getHourStamp(), /*#__PURE__*/React.createElement("br", null), translate('To'), ": ", new DateTime(item.endTime).getHourStamp())), /*#__PURE__*/React.createElement("td", null, getReportedBy(item)), /*#__PURE__*/React.createElement("td", null, new DateTime(item.reported).getHourStamp()));
    })))));
  }));
};

export default ReportHistory;